import { Id, Tag } from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";
import { LinkedTask } from "../linkers/types";

function removeTagFromTask(httpClient: HttpClient) {
  return (tag: Tag, taskId: Id) =>
    httpClient
      .sendHttpRequest<LinkedTask>({
        endpoint: `/tasks/${taskId}`,
        method: HttpMethods.GET,
      })
      .then((task) =>
        httpClient.sendHttpRequest<void>({
          endpoint: `/tasks/${taskId}`,
          method: HttpMethods.PATCH,
          data: {
            tags: task.tags.filter(
              (t) =>
                (typeof t === "object" ? t.name : t) !==
                (typeof tag === "object" ? tag.name : tag),
            ),
          },
        }),
      );
}

export { removeTagFromTask };
